import React, { Component } from 'react';
import Slider from 'react-slick';

import styles from './Gallery.module.css';

class Gallery extends Component {

    constructor(props){
        super(props);

        this.changeDots = this.changeDots.bind(this);
        this.changeDotsStyle = this.changeDotsStyle.bind(this);
        this.renderDots = this.renderDots.bind(this);
        this.renderGallery = this.renderGallery.bind(this);
    }

    resetSlider() {
        if(this.slider){
            this.slider.slickGoTo(0);
        }
        if(this.sliderDots){
            this.sliderDots.slickGoTo(0);
        }
    }

    changeDotsStyle(oldIndex, newIndex) {
        let element, startIdx, endIdx;
        let elements = document.getElementsByClassName("dot");
        for(let i=0; i<elements.length; i++){
            elements[i].classList.add("smallDot");
        }

        if(newIndex === 0){
            startIdx = 0;
            if(this.props.images.length > 5){
                endIdx = 3;
            }else{
                endIdx = 4;
            }
        } else {
            if(newIndex > 0 && newIndex < (this.props.images.length - 5)) {
                startIdx = newIndex+1;
                endIdx = newIndex+3;
            } else {
                startIdx = this.props.images.length-4;
                endIdx = this.props.images.length;
            }
        }

        for(let i=startIdx; i<=endIdx; i++){
            element = document.getElementById("dot-"+i);
            if(element)
                element.classList.remove("smallDot");
        }
    }

    changeDots(oldIndex, newIndex) {
        if(this.sliderDots){
            if(newIndex > oldIndex){
                if(newIndex >= 3){
                    this.sliderDots.slickNext();
                }
            } else {
                if(newIndex < this.props.images.length-3){
                    this.sliderDots.slickPrev();
                }
            }
        }
    }

    renderDots(dots) {
        let settings = {
            dots: false,
            infinite: false,
            arrows: false,
            variableWidth: true,
            beforeChange: this.changeDotsStyle,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1
        }

        let dotsRender = dots.map((dot,i) => {
            let className = "dot";
            if(i === 4 && dots.length > 5){
                className += " smallDot";
            }

            return (
                <div key={i} style={{width: 15}}>
                    <ul id={"dot-"+i} className={className}>{dot}</ul>
                </div>
            )
        });

        return (
            <Slider ref={ref => {this.sliderDots = ref}} {...settings}>
                {dotsRender}
            </Slider>
        );
    }

    renderGallery(){

        if(this.props.images && this.props.images.length > 0){

            let adjustImage;
            if(this.props.adjustImage){
                adjustImage = styles.imageContainerAdjust;
            }

            let dots = false;
            if(this.props.images.length > 1){
                dots = true;
            }

            let settings = {
                dots: dots,
                appendDots: this.renderDots,
                infinite: false,
                arrows: false,
                beforeChange: this.changeDots,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1
            };

            return (
                <div className={[styles.imageContainer, adjustImage].join(' ')}>
                    <Slider ref={ref => {this.slider = ref}} {...settings}>
                        {this.props.images}
                    </Slider>
                </div>
            );
        }

    }

    render(){
        return (
            <div>
                {this.renderGallery()}
            </div>
        );
    }

}

export default Gallery;